export const LOCALE_PREFIX = 'scenes.Gnosus.components.GroupStack.components.Content.components.EmptyContent'
